import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataSyncIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DataSync",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.93 15.3v-1.94a.4.4 0 0 1 .39-.36h16.01c.22 0 .39-.18.39-.39V9.5a.39.39 0 0 0-.39-.39H9.32a.39.39 0 0 1-.39-.39V6.76c0-.22-.19-.4-.41-.39a.36.36 0 0 0-.2.06l-6.15 3.96c-.18.12-.22.36-.1.53.03.04.06.08.1.1l6.13 4.6c.17.13.42.1.55-.08.05-.07.08-.15.08-.24m20.93 5.05-6.13-3.95a.393.393 0 0 0-.55.13.36.36 0 0 0-.06.2v2.02c0 .22-.18.39-.39.39l-15.44-.03a.39.39 0 0 0-.39.39v3.01c0 .22.18.39.39.39l15.42.05c.22 0 .39.18.39.39v1.88a.39.39 0 0 0 .63.31l6.13-4.6c.17-.13.2-.38.07-.55l-.06-.06Z"
    })
  }));
};